/**
 * Testi italiani dell'agente «voce» (ADR 0028): pulsante nella pagina del set, pannello
 * della conversazione, minuti, storico.
 *
 * La voce racconta il lavoro degli agenti e non esegue nulla: i testi lo dicono senza
 * giri di parole, perché chi parla non si aspetti che una frase detta diventi un ordine.
 */

/** Testi dell'agente vocale. */
export const voice = {
  /** Titolo del pannello. */
  title: 'Voce del set',
  /** Che cosa fa la voce. */
  intro: 'Chiedi a voce che cosa hanno fatto gli agenti, se ci sono problemi e che cosa resta da fare. La voce legge e risponde, non esegue lavoro: per far fare qualcosa scrivi all’Institore.',
  /** Scelta della modalità. */
  modeLabel: 'Modalità',
  /** Modalità voce. */
  modeVoice: 'Voce',
  /** Modalità chat. */
  modeText: 'Chat',
  /** Avvio. */
  start: 'Inizia',
  /** Arresto. */
  stop: 'Termina',
  /** Stati della conversazione. */
  status: {
    /** Non collegata. */
    idle: 'Non collegata',
    /** In collegamento. */
    connecting: 'Collegamento…',
    /** In ascolto. */
    listening: 'In ascolto',
    /** Sta parlando. */
    speaking: 'Sta parlando',
    /** Chat aperta. */
    chatting: 'Chat aperta',
  },
  /** Minuti del mese. */
  minutes: {
    /** Residuo. */
    left_one: '{{count}} minuto di voce rimasto questo mese',
    /** Residuo. */
    left_other: '{{count}} minuti di voce rimasti questo mese',
    /** Senza limite. */
    unlimited: 'Minuti di voce senza limite',
    /** Dettaglio. */
    detail: '{{used}} usati su {{plan}} del piano, più {{credits}} acquistati',
    /** Esauriti. */
    exhausted: 'Hai finito i minuti di voce del mese. Puoi usare la chat o acquistare altri minuti.',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura dei minuti non riuscita.',
  },
  /** Trascrizione in diretta. */
  transcriptTitle: 'Trascrizione',
  /** Trascrizione vuota. */
  transcriptEmpty: 'La conversazione compare qui mentre parli.',
  /** Chi parla. */
  you: 'Tu',
  /** Chi risponde. */
  agent: 'Voce',
  /** Campo della chat. */
  messageLabel: 'Messaggio',
  /** Invio nella chat. */
  send: 'Invia',
  /** Funzione spenta. */
  disabled: 'La voce non è attiva su questa installazione.',
  /** Errori. */
  errors: {
    /** Microfono negato. */
    microphone: 'Microfono non disponibile. Concedi il permesso al browser e riprova.',
    /** Avvio non riuscito. */
    start: 'Avvio della conversazione non riuscito. Riprova.',
    /** Minuti finiti. */
    exhausted: 'Minuti di voce finiti per questo mese. Usa la chat o acquista altri minuti.',
    /** Conversazione interrotta. */
    dropped: 'Conversazione interrotta. Inizia di nuovo.',
  },
  /** Scelta della voce (nel pannello e nelle Impostazioni). */
  picker: {
    /** Etichetta del campo. */
    label: 'Voce',
    /** Voci nel menu. */
    option: {
      /** Voce femminile. */
      female: '{{name}}, femminile',
      /** Voce maschile. */
      male: '{{name}}, maschile',
    },
    /** Spiegazione nelle Impostazioni. */
    hint: 'La voce con cui ti risponde l’agente vocale. Vale dalla prossima conversazione.',
    /** Salvata. */
    saved: 'Voce salvata. La senti dalla prossima conversazione.',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura delle voci non riuscita.',
    /** Salvataggio non riuscito. */
    saveFailed: 'Voce non salvata. Riprova.',
  },
  /** Storico. */
  history: {
    /** Titolo. */
    title: 'Conversazioni precedenti',
    /** Vuoto. */
    empty: 'Nessuna conversazione precedente.',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura dello storico non riuscita.',
    /** Durata e minuti. */
    summary: '{{when}}, {{duration}}, {{mode}}',
    /** Trascrizione non ancora arrivata. */
    noTranscript: 'Trascrizione non ancora disponibile.',
    /** Durata in minuti e secondi. */
    duration: '{{minutes}} min {{seconds}} s',
  },
};

/** Forma dei testi dell'agente vocale. */
export type Voice = typeof voice;
